import React, { useEffect } from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from '@material-ui/core';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

import * as S from '../../styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onIconClick,
}) {
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleRowClick = (row) => {
    setSelectedRow(row);
  };

  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleRowClick(item)}
              >
                {cells.map((cell, indexKey) => (
                  <TableCell
                    key={`table-cell-body-${indexKey}`}
                    align={cell.align || 'left'}
                  >
                    <Box
                      display="flex"
                      // alignItems="center"
                      alignItems={cell.align || 'center'}
                      style={{
                        justifyContent:
                          cell.id === 'acao' ? 'flex-end' : 'start',
                      }}
                    >
                      {cell.format && (
                        <>
                          {!cell.action && (
                            <label
                              style={
                                isFunction(cell.styled)
                                  ? cell.styled(item[cell.id])
                                  : { textAlign: cell.align, flex: 1 }
                              }
                            >
                              {cell.format(item[cell.id])}
                            </label>
                          )}
                        </>
                      )}
                      {!cell.format && (
                        <label
                          style={
                            isFunction(cell.styled)
                              ? cell.styled(item[cell.id])
                              : {}
                          }
                        >
                          {item[cell.id]}
                        </label>
                      )}
                      {cell.action &&
                        cell.action.map((acao) => (
                          <div title={acao.label}>
                            {item.atendimentoFechado !== 'S' &&
                            acao.edicao !== 'emitir' ? (
                              <acao.botao
                                style={
                                  isFunction(cell.styledIcon)
                                    ? cell.styledIcon(item[cell.id])
                                    : {
                                        marginLeft: item[cell.id] ? 8 : 0,
                                        color: '#999999',
                                        cursor: 'pointer',
                                      }
                                }
                                onClick={() =>
                                  onIconClick(
                                    acao.edicao,
                                    item.atendimentoFechado,
                                    item.idatendimento,
                                    item.idveiculo,
                                    acao?.origem,
                                    item?.idmovimentacao,
                                    item?.tipolocomotivaveiculo
                                  )
                                }
                              />
                            ) : (
                              <>
                                {acao.edicao !== 'fim' &&
                                  item.atendimentoFechado === 'S' && (
                                    <acao.botao
                                      style={
                                        isFunction(cell.styledIcon)
                                          ? cell.styledIcon(item[cell.id])
                                          : {
                                              marginLeft: item[cell.id] ? 8 : 0,
                                              color: '#999999',
                                              cursor: 'pointer',
                                            }
                                      }
                                      onClick={() =>
                                        onIconClick(
                                          acao.edicao,
                                          item.atendimentoFechado,
                                          item.idatendimento,
                                          item.idveiculo,
                                          acao?.origem,
                                          item?.idmovimentacao,
                                          item?.tipolocomotivaveiculo
                                        )
                                      }
                                    />
                                  )}
                              </>
                            )}
                          </div>
                        ))}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
      format: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  showDefaultValue: PropTypes.string,
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  showDefaultValue: 'S',
};
